var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back"},[_c('el-button',{on:{"click":_vm.jump}},[_vm._v("返回")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }